import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { GlobalErrorHandler } from '../errorhandlers/apm-error-handler';

/**
 * An HTTP interceptor that adds a unique correlation ID to each outgoing request.
 *
 * The interceptor generates a new UUID for every HTTP request and sets it as the value
 * of the `X-Correlation-ID` header. This allows requests to be tracked and correlated
 * across distributed systems for logging and debugging purposes.
 *
 * @implements {HttpInterceptor}
 */
@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {
  constructor(private globalErrorHandler: GlobalErrorHandler) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const correlationId = uuidv4();
    const cloned = req.clone({
      setHeaders: {
        'X-Correlation-ID': correlationId,
      },
    });
    return next.handle(cloned).pipe(
      catchError((err: HttpErrorResponse) => {
        this.globalErrorHandler.handleError(err);
        return throwError(err);
      }),
    );
  }
}
